import { PageHeader } from "../components/site/PageHeader";
import { legalPages } from "../data/legalPages";

export default function Legal({ page }) {
  const data = legalPages[page];
  return (
    <>
      <PageHeader testId={`legal-${page}-header`} eyebrow="Informations légales" lines={[data.title]} intro={data.intro} />
      <section className="pb-24 sm:pb-32">
        <div className="container-site max-w-3xl space-y-12">
          {data.sections.map((s) => (
            <div key={s.title} className="border-t border-[#D4A359]/20 pt-8">
              <h2 className="font-display text-2xl sm:text-3xl">{s.title}</h2>
              <ul className="mt-5 space-y-3 text-[#D6CFC0] leading-relaxed">
                {s.lines.map((l) => <li key={l}>{l}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
